import { render } from "./Inliner.vue?vue&type=template&id=f2b0ce3a&ts=true&lang=pug"
import script from "./Inliner.vue?vue&type=script&setup=true&lang=ts"
export * from "./Inliner.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__